import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAlerts, resetStateAlerts } from "../../app/slices/alertsSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import { Button } from "@mui/material";
import AlertDialog from "./AlertDialog";
import moment from "moment";
import { dateFormat } from "../../app/utils";

const AlertManagement = () => {
  const { data, status, error } = useSelector(({ alerts }) => alerts.get);
  const [list, setList] = useState(null);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedAlert, setSelectedAlert] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "created_date",
      label: "Date Posted",
    },
    {
      name: "title",
      label: "Title",
    },
    {
      name: "description_alt",
      label: "Description",
    },
    {
      name: "statusDisplay",
      label: "Status",
      options: {
        align: "center",
      },
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateAlerts());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      let _list = [];
      data?.forEach((row) => {
        _list.push({
          ...row,
          created_date: moment(row?.created_date).format(dateFormat),
          statusDisplay:
            row?.status === "A"
              ? "Active"
              : row?.status === "I"
              ? "Inactive"
              : row?.status,
          description_alt:
            row?.description?.length > 60
              ? `${row?.description?.substring(0, 59)}...`
              : row?.description,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [data]);

  //methods
  const loadResources = () => {
    dispatch(resetStateAlerts());
    dispatch(fetchAlerts());
  };

  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        <Button
          variant="outlined"
          onClick={() => {
            setMethod("ADD");
            setSelectedAlert(null);
            setIsOpenDialog(true);
          }}
        >
          + Post Alert
        </Button>

        {status === "idle" && error === null && list && (
          <AppDataTable
            id="alerts-list"
            actions={[
              {
                action: "View",
                onClick: (item) => {
                  setMethod("VIEW");
                  setSelectedAlert({
                    ...item,
                    alertId: item?.alert_id,
                    references: (() => {
                      let _refs = [];
                      (item?.links || []).forEach((item) => {
                        _refs.push(JSON.parse(item));
                      });
                      return _refs;
                    })(),
                    attachments: (() => {
                      let _attachments = [];
                      (item?.attachments || []).forEach((item) => {
                        _attachments.push({
                          name: item,
                        });
                      });
                      return _attachments;
                    })(),
                  });
                  setIsOpenDialog(true);
                },
              },
              {
                action: "Update",
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedAlert({
                    ...item,
                    alertId: item?.alert_id,
                    references: (() => {
                      let _refs = [];
                      (item?.links || []).forEach((item) => {
                        _refs.push(JSON.parse(item));
                      });
                      return _refs;
                    })(),
                    attachments: (() => {
                      let _attachments = [];
                      (item?.attachments || []).forEach((item) => {
                        _attachments.push({
                          name: item,
                        });
                      });
                      return _attachments;
                    })(),
                  });
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={list}
            emptyMessage="No alerts found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName={`TzFincert alerts ${moment().format(
              "DD-MMM-YYYY"
            )}`}
          />
        )}
        {status === "loading" && (
          <LoadingContainer message={"Loading alerts..."} />
        )}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* Alert dialog */}
      {isOpenDialog && (method === "UPDATE" ? selectedAlert : true) && (
        <AlertDialog
          selectedAlert={selectedAlert}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              setSelectedAlert(null);
              if (refresh) {
                loadResources();
              }
            }
          }}
          readOnly={method === "VIEW"}
          title={
            method === "VIEW"
              ? "View Alert"
              : method === "ADD"
              ? "Post Alert"
              : "Update Alert"
          }
        />
      )}
      {/* Alert dialog */}
    </>
  );
};

export default AlertManagement;
